module.exports = __webpack_public_path__ + "media/images/flags/64/Saudi-Arabia-2c547b1fdd4201226308c8d49979d0a5.png";